import { RatecardProjectAnnouncementsSlice } from './ratecardProjectAnnouncementsSlice';

export default RatecardProjectAnnouncementsSlice.reducer;
